import React, { useContext } from 'react';
import useStyles from './styles';
import { Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { CurrencyFormats, PaymentModes } from '../../utils/index';
import { PaymentMode } from '../../App';
import { TransactionTypeName } from '../../constants';

const OrderItems = ({ orderItems, amount, currency }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const paymentMode = useContext(PaymentMode);
  const displayOrderItems = orderItems?.reverse() || [];
  const transactionTypeCounts = displayOrderItems.reduce((counts, item) => {
    const transactionTypeId = item.transactionTypeId;
    counts[transactionTypeId] = (counts[transactionTypeId] || 0) + 1;
    return counts;
  }, {});
  const displayedTransactionTypeCounts = {};

  return (
    <div className={classes.root}>
      {displayOrderItems.map((item) => {
        const transactionTypeName = TransactionTypeName[item.transactionTypeId];
        displayedTransactionTypeCounts[item.transactionTypeId] = (
          displayedTransactionTypeCounts[item.transactionTypeId] || 0
        ) + 1;
        const transactionTypeIndex = displayedTransactionTypeCounts[item.transactionTypeId];
        const displayTransactionTypeName = transactionTypeCounts[item.transactionTypeId] > 1
          ? `${transactionTypeName} ${transactionTypeIndex}`
          : transactionTypeName;

        return (
          <div key={item.itemRef} className={classes.row}>
            <div className="product_text">
              {item?.description}
              <Typography className={`${classes.description} product_text`}>
                {displayTransactionTypeName}
              </Typography>
            </div>
            {paymentMode != PaymentModes.Token ? (
              <div className="product_text">
                {item?.currencyIso} {item?.amount?.toFixed(2)}
              </div>
            ) : ('')}
          </div>
        );
      })}
      {paymentMode != PaymentModes.Token ? (
        <div className={classes.row}>
          <div className="product_text">{t('Total')}</div>
          <div className="product_text">
            {currency}{' '}
            {CurrencyFormats(amount?.toFixed(2))}
          </div>
        </div>
      ) : ( <div className={classes.row}></div>)}
    </div>
  );
};

export default OrderItems;
